// تمِ پنل: تیره، روشن، یا «بایر» (هم‌شکلِ سایتِ عمومیِ بایر کاشان). انتخابِ کاربر هم در کوکی (تا اسکریپتِ ابتدای صفحه پیش از
// اولین رندر بخواندش و صفحه یک لحظه با تمِ اشتباه دیده نشود) و هم در localStorage
// نگه داشته می‌شود. پیش‌فرض همان تمِ تیره‌ی قبلی است.

export type PanelTheme = "dark" | "light" | "bayer";
export const PANEL_THEMES: readonly PanelTheme[] = ["dark", "light", "bayer"];

export const THEME_COOKIE = "panel-theme";
export const DEFAULT_THEME: PanelTheme = "dark";
export const THEME_CHANGE_EVENT = "panel-theme-change";

export const THEME_META_COLORS: Record<PanelTheme, string> = {
  dark: "#020617",
  light: "#d3dae4",
  bayer: "#002147",
};

// این رشته عیناً داخلِ <head> اجرا می‌شود (پیش از hydrate)، پس باید ES5 و بدونِ
// وابستگی بماند.
export const THEME_BOOTSTRAP_SCRIPT = `(function(){try{var d=document.documentElement;var m=document.cookie.match(/(?:^|; )${THEME_COOKIE}=(light|dark|bayer)/);var t=m?m[1]:null;if(!t){try{t=localStorage.getItem('${THEME_COOKIE}')}catch(e){}}if(t!=='light'&&t!=='dark'&&t!=='bayer'){t='${DEFAULT_THEME}'}d.setAttribute('data-theme',t);var c=document.querySelector('meta[name="theme-color"]');if(c){c.setAttribute('content',t==='light'?'${THEME_META_COLORS.light}':t==='bayer'?'${THEME_META_COLORS.bayer}':'${THEME_META_COLORS.dark}')}}catch(e){}})();`;

export function readTheme(): PanelTheme {
  if (typeof document === "undefined") return DEFAULT_THEME;
  const value = document.documentElement.getAttribute("data-theme");
  return value === "light" || value === "bayer" ? value : "dark";
}

export function applyTheme(theme: PanelTheme) {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", THEME_META_COLORS[theme]);
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${THEME_COOKIE}=${theme}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
  try {
    localStorage.setItem(THEME_COOKIE, theme);
  } catch {
    // حالتِ خصوصی/مسدودبودنِ storage؛ کوکی کافی است.
  }
  window.dispatchEvent(new CustomEvent<PanelTheme>(THEME_CHANGE_EVENT, { detail: theme }));
}
